"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFulfillers = getFulfillers;
exports.getFulfillmentLocations = getFulfillmentLocations;
exports.getMerchants = getMerchants;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _http = require("./http");

var _helpers = require("./helpers");

var _environment = require("../constants/environment");

var REACT_APP_FULFILLER_IDENTITY_BASE_URL = _environment.ENVIRONMENT_VARIABLE_NAMES.REACT_APP_FULFILLER_IDENTITY_BASE_URL,
    REACT_APP_MERCHANT_CONFIG_BASE_URL = _environment.ENVIRONMENT_VARIABLE_NAMES.REACT_APP_MERCHANT_CONFIG_BASE_URL,
    REACT_APP_FULFILLMENT_LOCATION_BASE_URL = _environment.ENVIRONMENT_VARIABLE_NAMES.REACT_APP_FULFILLMENT_LOCATION_BASE_URL;
/**
 * @description get list of fulfillers
 * @returns {Array}
 */

function getFulfillers(_x) {
  return _getFulfillers.apply(this, arguments);
}
/**
 * @description get list of merchants
 * @returns {Array}
 */


function _getFulfillers() {
  _getFulfillers = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var accessToken, environment, config, url, _yield$getData, data;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            accessToken = _ref.accessToken, environment = _ref.environment;
            config = {
              params: {
                showFlags: false
              }
            };
            url = "".concat((0, _environment.env)(REACT_APP_FULFILLER_IDENTITY_BASE_URL, environment), "/v1/fulfillers");
            _context.next = 5;
            return (0, _http.getData)({
              accessToken: accessToken
            }, url, config);

          case 5:
            _yield$getData = _context.sent;
            data = _yield$getData.data;
            return _context.abrupt("return", (0, _helpers.filterTestValues)({
              data: data,
              fieldName: 'name',
              regex: 'test'
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getFulfillers.apply(this, arguments);
}

function getMerchants(_x2) {
  return _getMerchants.apply(this, arguments);
}
/**
 * @description get list of fulfillment locations
 * @returns {Array}
 */


function _getMerchants() {
  _getMerchants = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var accessToken, environment, url, config, _yield$getData2, data;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accessToken = _ref2.accessToken, environment = _ref2.environment;
            url = "".concat((0, _environment.env)(REACT_APP_MERCHANT_CONFIG_BASE_URL, environment), "/v0/merchants");
            config = {
              params: {
                verbose: false
              }
            };
            _context2.next = 5;
            return (0, _http.getData)({
              accessToken: accessToken
            }, url, config);

          case 5:
            _yield$getData2 = _context2.sent;
            data = _yield$getData2.data;
            return _context2.abrupt("return", (0, _helpers.mergeMerchants)((0, _helpers.filterTestValues)({
              data: data,
              fieldName: 'displayName',
              regex: 'test'
            })));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getMerchants.apply(this, arguments);
}

function getFulfillmentLocations(_x3) {
  return _getFulfillmentLocations.apply(this, arguments);
}

function _getFulfillmentLocations() {
  _getFulfillmentLocations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3) {
    var accessToken, environment, url, _yield$getData3, data;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            accessToken = _ref3.accessToken, environment = _ref3.environment;
            url = "".concat((0, _environment.env)(REACT_APP_FULFILLMENT_LOCATION_BASE_URL, environment), "/v1/fulfillmentlocations");
            _context3.next = 4;
            return (0, _http.getData)({
              accessToken: accessToken
            }, url);

          case 4:
            _yield$getData3 = _context3.sent;
            data = _yield$getData3.data;
            return _context3.abrupt("return", (0, _helpers.filterTestValues)({
              data: data,
              fieldName: 'name',
              regex: 'test'
            }));

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getFulfillmentLocations.apply(this, arguments);
}